module.exports = __webpack_public_path__ + "static/img/11.3ad62b8d.png";